import React from 'react';
import OfflineActivityAnimation from './index';
import styles from './index.module.scss';

interface Props {
  timer: { duration: number; rotate: number };
}

const OfflineSpinner: React.FC<Props> = (props: Props) => {
  const { timer } = props;
  return (
    <div className={styles.root}>
      <div className={styles.layer} />
      <div className={styles.animWrap}>
        <OfflineActivityAnimation
          duration={timer.duration}
          rotate={timer.rotate}
        />
      </div>
    </div>
  );
};

export default OfflineSpinner;
